import { useCallback } from 'react';
import { string2RGB } from '../../../models/color';
import { useColor } from './useColor';
export function useSetColor() {
  var manager = useColor();
  return useCallback(function (str) {
    var rbga = string2RGB(str);

    if (rbga == null) {
      console.error('str=' + str + 'is an invalid color string');
      return;
    }

    var color = manager.getColor().setRGBA(rbga);
    manager.emitColorChange(color);
  }, []);
}